/**
 * 消息操作控件
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { CSSProperties, useContext } from "react";
import { Dropdown, Menu, Divider, Tooltip } from "antd";
import { WithTranslation, withTranslation } from "react-i18next";
import IconFont from "@/components/icon";
import "./index.less";
import {
  ChatMessage,
  Employee,
  Session,
  ChatMessagePlusEmitBody,
  JoySpaceDocumentMessage,
  SessionType,
  NoticeMessageRespType,
  UnifiedNoticeMessageEmitBody
} from "@/types/chat";
import { ClickParam } from "antd/lib/menu";
import {
  getReplyMessageDesc,
  getMessageSendType,
  isCloudFileFunc,
  checkisLiveCard,
  isOuterContacts,
  isCrossPlatformGroupSession,
  isExternalGroupSession,
  isTemp2CommonCardMsg,
  isQuillMsg,
  checkIsSummaryCard,
  isImageTextCardMessage,
  isOrgNoticeMultiMessage
} from "@/utils/chat/message";
import { MessageSendType } from "@/types/chat/enum";
import ChatEvent from "@/components/chat/view/ChatEvent";
import { ChatMessageType, MessageStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import {
  checkScheduleVisible,
  checkTaskVisible,
  checkRemindVisible,
  isGroupOwner,
  isGroupAdmin
} from "@/utils/chat/group";
import { FocusSDK, isFocusEnv } from "@/utils";
import chatConfig from "@/components/chat/config";

import config, { ConfigEnum } from "@/config/config";
import { analysisLog } from "@/utils/logAnalytics";
import { VoiceMessageMap } from "@/types/chat/State";
import bus from "@/utils/bus";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import ChatContext from "@/components/chat/context";
import { crossAppSwitch, getFileOperateAuthority } from "@/utils/tools";
import { isMeetingInviteMsg } from "@/baseComponents/Meeting/utils";
import { allEmoji, checkFileIsExpired } from "../../utils/commonMessageModal";
import { isQuickReplyCard, isQuickReplyTypeCard, isShortLinkMessage } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import { map } from "lodash";
import { isOrgChatSession } from "@/utils/chat/session";
interface MessageOperateProps {
  style?: CSSProperties;
  message: ChatMessage & ChatMessagePlusEmitBody;
  voiceMessageMap: VoiceMessageMap[];
  selectedSession: Session;
  currentEmployee: Employee;
  onDropMenuChange: Function;
  unLock: Function;
  isRightClick?: boolean;
  groupRosterIdentity: any;
  isMeetingChat?: boolean;
  assistantAI?: any;
  isSmall?: boolean;
  quickReplys?: any[];
  handleFile: (param: ClickParam) => void;
  handleFileTo: (param: ClickParam) => void;
  copyOperate: (index: ClickParam) => void;
  undoOperate: (param: ClickParam) => void;
  undoMsgOperate: (param: ClickParam) => void;
  adminRevoke: (param: ClickParam) => void;
  forwardOperate: (param?: ClickParam) => void;
  deleteOperate: (param: ClickParam) => void;
  destroyOperate: (param: ClickParam) => void;
  scheduleOperate: (param: ClickParam) => void;
  taskOperate: (param: ClickParam) => void;
  remindOperate: (param: ClickParam | React.MouseEvent<HTMLDivElement>) => void;
  selectMoreFn: (param: ClickParam) => void;
  turnTextOperate: (param: ClickParam) => void;
  handleMsgTag: (param: ClickParam) => void;
  openQuickReply?: (param: ClickParam) => void;
  skipRawMsg: (param: ClickParam) => void;
  updateSessionMessageMid?: Function;
  sendReplyEmoji?: (param: ClickParam) => void;
  currentFileControl?: any[];
}

interface MoreIconAction {
  text: string;
  event: Function;
}

type IMessageOperateProps = Readonly<MessageOperateProps & WithTranslation>;

interface MessageOperateState {
  type: string;
  moreActive: boolean;
  expressionVisible: boolean;
  times: boolean;
  topStatus: boolean;
}
let timestamps: string;
class MessageOperate extends React.Component<IMessageOperateProps, MessageOperateState> {
  messageTime: number;
  tiem: number;
  // eslint-disable-next-line @typescript-eslint/member-ordering
  static contextType = GlobalContext;
  constructor(props: IMessageOperateProps) {
    super(props);
    this.state = {
      type: "",
      moreActive: false,
      expressionVisible: false,
      times: false,
      topStatus: false
    };
    // this.messageTime = props.message.timestamp;
    this.messageTime = props.message.localSendTimestamp || 0;
    this.tiem = props.message.localSendTimestamp || 0;
  }

  onVisibleChange = (visible: boolean) => {
    analysisLog("Xtbg_Msg", "Frequency");
    // Bus.emit('contextmenu:short-link:hide');
    bus.emit("message-item-chatitem", true);
    this.setState({ expressionVisible: false });
  };
  showOperateFn = (operate?: string) => {
    const { message } = this.props;
    if (isTemp2CommonCardMsg(message)) {
      const { common_card = {} } = (message as any).data[0];
      const msgOptionConfig = common_card.msgOptionConfig || {};
      // if (!Object.keys(msgOptionConfig).length) {
      //   return false;
      // }
      const values = Object.values(msgOptionConfig);
      const show = values.some((item) => item);
      return (!operate && show) || (operate && msgOptionConfig[operate]);
    }
    return true;
  };
  getOperateAuth = (key: string) => {
    const { message, currentFileControl } = this.props;
    const auth = getFileOperateAuthority(key, currentFileControl || [], message?.fileTag || 0);
    return auth;
  };
  // eslint-disable-next-line complexity
  getQuickReplysNode = () => {
    const {
      quickReplys = [],
      sendReplyEmoji
    } = this.props;
    return (
      <div className="quick-emoji-wrap">
        <div className="title">常用语表情</div>
        <div className="content">
          {quickReplys.map((item: any) => (
            <div
              className="item"
              key={item.id}
              onClick={() => sendReplyEmoji?.(item)}
              style={{
                background: item.backgroundColor,
                borderColor: item.frameColor,
                color: item.textColor
              }}
            >
              {item.detail}
            </div>
          ))}
        </div>
      </div>
    )
  };
  // eslint-disable-next-line complexity
  getDropdownMenu = (trigger: string) => {
    const canCreateTask = config[ConfigEnum.EXTERNAL_CONTACTS_CREAT_TASK];
    const {
      selectedSession,
      message,
      currentEmployee,
      voiceMessageMap,
      groupRosterIdentity,
      isMeetingChat,
      assistantAI,
      isSmall,
      quickReplys = [],
      sendReplyEmoji
    } = this.props;
    // let msg: any = message;
    // if (msg.type === ChatMessageType.GROUPNOTICE) return;
    const sendType = getMessageSendType(message, currentEmployee);
    const type = this.props.message.type;
    const { appRuntimeEnv } = this.context;
    const { im, config: commConfig } = appRuntimeEnv;
    const quickReply = commConfig?.quickReply || {};
    let bts_revoke_times: any = {};
    const bts_revoke_times_str = window._BTS_CONFIG?.REACT_APP_CHAT_REVOKE_TIMES || "";
    try {
      if (bts_revoke_times_str) {
        bts_revoke_times = JSON.parse(bts_revoke_times_str);
      }
    } catch (e) {}
    // 消息（文本)撤回时间 如果ducc读取不到 默认是两小时
    const revoketime_text = bts_revoke_times?.chatRevokeTime || im.chatRevokeTime || 7200000;
    // 文件、图片、视频类型的消息撤回时间 默认是24小时
    const revoketime_file = bts_revoke_times?.chatRevokeTime2 || im.chatRevokeTime2 || 86400000;
    const adminRevokeTime = bts_revoke_times?.adminRevokeTime || im.adminRevokeTime || 864000000;
    // 右键开启快捷回复
    const rightOpenReply = quickReply.rightOpenReply || false;
    const expireTime =
      type === ChatMessageType.FILE ||
      type === ChatMessageType.EGOV_FILE ||
      type === ChatMessageType.IMAGE ||
      type === ChatMessageType.VIDEO
        ? revoketime_file
        : revoketime_text;
    // console.log(
    //     '撤回时间判断',
    //     new Date(),
    //     new Date(this.messageTime),
    //     new Date().getTime() - this.messageTime,
    //     expireTime,
    //     new Date().getTime() - this.messageTime > expireTime
    // );
    const more2 =
      new Date().getTime() - this.messageTime <= 0
        ? true
        : new Date().getTime() - this.messageTime > expireTime;
    let type1: any;
    message.plusList?.filter((item) => {
      if (item.userId === currentEmployee.userId && item.statusType === MessageStatus.SUCCESS) {
        type1 = MessageSendType.OWNER;
        timestamps = item.userId;
        this.tiem = item.timestamp;
      } else {
        timestamps = "";
      }
    });
    const more3 = new Date().getTime() - this.tiem > im.chatRevokeTime;
    const isOutApp = selectedSession.isGroup
      ? isCrossPlatformGroupSession(selectedSession)
      : isOuterContacts(selectedSession, currentEmployee);
    const isMeetingCard = (message as any).meetingCard && (message as any).meetingCard.meetingId;
    const showRevoke_admin =
      new Date().getTime() - this.messageTime > adminRevokeTime ||
      type === ChatMessageType.GROUPNOTICE ||
      type === ChatMessageType.SOLITAIRE;
    // 是否开启回复
    const canOpenReply =
      sendType === MessageSendType.OWNER &&
      !isQuillMsg(message?.quillJson) &&
      !isMeetingCard &&
      !isShortLinkMessage(message) &&
      !isQuickReplyTypeCard(message);
    const canEmojiReply =
      !isQuillMsg(message?.quillJson) &&
      !isMeetingCard &&
      !isShortLinkMessage(message) &&
      !isQuickReplyCard(message) &&
      quickReplys.length;
    // 过期图片、文件、视频处理右键菜单
    const showOwnerUndo =
      (type1 === MessageSendType.OWNER && !more3) || (sendType === MessageSendType.OWNER && !more2);
    if (message.statusType === MessageStatus.EXPIRED) {
      return (
        <Menu selectedKeys={[""]}>
          <Menu.Item
            onClick={this.props.deleteOperate}
            clstag="pageclick|keycount|Xtbg_Msg|InfoDelete"
          >
            <div className="operate-menu-item">
              <IconFont className="icon" type="iconapp_ic_delete" />
              <span>{this.props.t("delete")}</span>
            </div>
          </Menu.Item>
        </Menu>
      );
    }
    if (selectedSession.isSecret) {
      return (
        <Menu selectedKeys={[""]}>
          {/* 撤回 */}
          {sendType === MessageSendType.OWNER &&
            this.messageTime &&
            !more2 &&
            type !== ChatMessageType.GROUPNOTICE && (
              <Menu.Item
                onClick={this.props.undoOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoRevoke"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconapp_btn_undo" />
                  <span>{this.props.t("undo")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 多选 */}
          <Menu.Item
            onClick={this.props.selectMoreFn}
            clstag="pageclick|keycount|Xtbg_Msg|InfoMutiSelect"
          >
            <div className="operate-menu-item">
              <IconFont className="icon" type="iconapp_btn_select" />
              <span>{this.props.t("select_more")}</span>
            </div>
          </Menu.Item>
          {/* 删除 */}
          <Menu.Item
            onClick={this.props.deleteOperate}
            clstag="pageclick|keycount|Xtbg_Msg|InfoDelete"
          >
            <div className="operate-menu-item">
              <IconFont className="icon" type="iconapp_ic_delete" />
              <span>{this.props.t("delete")}</span>
            </div>
          </Menu.Item>
          {/* 销毁 */}
          {sendType === MessageSendType.OWNER && (
            <Menu.Item
              onClick={this.props.destroyOperate}
              clstag="pageclick|keycount|Xtbg_Msg|InfoDestory"
            >
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconic_pc_im_burn1" />
                <span>{this.props.t("destroy")}</span>
              </div>
            </Menu.Item>
          )}
        </Menu>
      );
    }
    if (message.plusList === undefined) {
      const target = voiceMessageMap.find((item: VoiceMessageMap) => item.mid === message.mid);
      // console.log('target', target);
      const turnTheTextStatus = target ? true : false;
      return (
        <Menu selectedKeys={[""]}>
          {/* 文件另存为 */}
          {(type === ChatMessageType.FILE ||
            type === ChatMessageType.EGOV_FILE ||
            type === ChatMessageType.IMAGE ||
            type === ChatMessageType.VIDEO) &&
            this.getOperateAuth("saveAs") &&
            isFocusEnv() && (
              <Menu.Item
                onClick={this.props.handleFile}
                clstag="pageclick|keycount|Xtbg_Msg|InfoSave"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconlingcunwei2" />
                  <span>{this.props.t("click-to-saveAs")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 文件转存到 */}
          {/* {!isMeetingChat &&
            type === ChatMessageType.FILE &&
            !isOutApp &&
            crossAppSwitch("joyspace") && (
              <Menu.Item
                onClick={this.props.handleFileTo}
                clstag="pageclick|keycount|Xtbg_Msg|InfoRollover"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconic_pc_im_Export" />
                  <span>{this.props.t("click-to-saveTo")}</span>
                </div>
              </Menu.Item>
            )} */}
          {/* 常用语 */}
          {trigger === "right-click" && canEmojiReply && type === ChatMessageType.TEXT && (
            <Menu.SubMenu
              title={
                <div className="operate-menu-item">
                  <IconFont className="icon" type="icontiebiaoqing" />
                  <span className="menu-item-text">{this.props.t("quick_emoji")}</span>
                </div>
              }
            >
              <div className="quick-emoji-wrap">
                <div className="title">常用语表情</div>
                <div className="content">
                  {quickReplys.map((item: any) => (
                    <div
                      className="item"
                      key={item.id}
                      onClick={() => sendReplyEmoji?.(item)}
                      style={{
                        background: item.backgroundColor,
                        borderColor: item.frameColor,
                        color: item.textColor
                      }}
                    >
                      {item.detail}
                    </div>
                  ))}
                </div>
              </div>
            </Menu.SubMenu>
          )}
          {/* 复制 --hujun */}
          {((type === ChatMessageType.TEXT && !isMeetingCard) ||
            ((type as any) === NoticeMessageRespType.UNIFIED_NOTICE_MESSAGE &&
              !isImageTextCardMessage(this.props.message)) ||
            (type === ChatMessageType.IMAGE && isFocusEnv())) && (
            <Menu.Item
              onClick={this.props.copyOperate}
              clstag="pageclick|keycount|Xtbg_Msg|InfoCopy"
            >
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconfuzhi" />
                <span>{this.props.t("copy")}</span>
              </div>
            </Menu.Item>
          )}
          {/* 多选 */}
          {type !== ChatMessageType.GROUPNOTICE &&
            type !== ChatMessageType.SOLITAIRE &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.NOTICE &&
            !isOrgChatSession(selectedSession) &&
            !checkIsSummaryCard(message) &&
            !checkisLiveCard(message) &&
            !checkIsSummaryCard(message) &&
            this.showOperateFn("multiSelectEnabled") && (
              <Menu.Item
                onClick={this.props.selectMoreFn}
                clstag="pageclick|keycount|Xtbg_Msg|InfoMutiSelect"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconduoxuan" />
                  <span>{this.props.t("select_more")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 引用 */}
          {trigger === "right-click" && type !== ChatMessageType.VOICE &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.NOTICE &&
            !checkIsSummaryCard(message) &&
            !isOrgChatSession(selectedSession) &&
            this.showOperateFn("replyEnabled") && (
              <Menu.Item
                onClick={this.handleReplyClick}
                clstag="pageclick|keycount|Xtbg_Msg|InfoQuote"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconhuifu" />
                  <span>{this.props.t("quote")}</span>
                </div>
              </Menu.Item>
            )}
            {trigger === "right-click" && type !== ChatMessageType.VOICE &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.NOTICE &&
            !checkIsSummaryCard(message) &&
            !isOrgChatSession(selectedSession) &&
            this.showOperateFn("replyEnabled") && (
              <Menu.Divider />
            )}
          {/* 转发 */}
          {/* 直播卡片不支持转发 */}
          {trigger === "right-click" && type !== ChatMessageType.VOICE &&
            type !== ChatMessageType.SOLITAIRE &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.NOTICE &&
            !checkisLiveCard(message) &&
            !isOrgNoticeMultiMessage(message) &&
            this.getOperateAuth("forward") &&
            this.showOperateFn("forwardEnabled") && (
              <Menu.Item
                onClick={this.props.forwardOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoShare"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconFrame4" />
                  <span>{this.props.t("forwarding")}</span>
                </div>
              </Menu.Item>
            )}
          {/* <Menu.Divider />     */}
          {/* 撤回 */}
          {sendType === MessageSendType.OWNER &&
            this.messageTime &&
            !more2 &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            this.showOperateFn("revokeEnabled") && (
              <Menu.Item
                onClick={this.props.undoOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoRevoke"
              >

                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconchehui" />
                  <span>{this.props.t("undo")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 管理员or群主撤回群成员消息 */}
          {(isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity)) &&
            this.messageTime &&
            !showRevoke_admin &&
            !showOwnerUndo &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            this.showOperateFn("revokeEnabled") && (
              <Menu.Item onClick={this.props.adminRevoke}>
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconci_im_guanliyuanchehui" />
                  <span>{this.props.t("undo-admin")}</span>
                </div>
              </Menu.Item>
            )}
          {/* <Menu.Divider /> */}

          {/** 消息引用定位 */}
          {!isSmall && !!message.replyMsgs?.length && (
            <Menu.Item onClick={this.props.skipRawMsg}>
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconhuidaoyuanwen1" />
                <span>{this.props.t("skip_rawMsg")}</span>
              </div>
            </Menu.Item>
          )}
          {/* 语音转文字 */}
          {type === ChatMessageType.VOICE && crossAppSwitch("turnVoiceToText") && !turnTheTextStatus && (
            <Menu.Item onClick={this.props.turnTextOperate}>
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconbtn_turn_text" />
                <span>{this.props.t("turn_text")}</span>
              </div>
            </Menu.Item>
          )}
          {/* <Menu.Divider /> */}
          {/* 任务 */}
          {((type === ChatMessageType.TEXT && !isMeetingCard) ||
            type === ChatMessageType.FILE ||
            type === ChatMessageType.IMAGE ||
            // 内部群支持组通知转任务
            (type === ChatMessageType.GROUPNOTICE && !isExternalGroupSession(selectedSession)) ||
            isCloudFileFunc(this.props.message)) &&
            checkTaskVisible({ selectedSession }) &&
            !isOutApp &&
            crossAppSwitch("joywork", currentEmployee, appRuntimeEnv) &&
            !this.props.message?.quillImage?.length &&
            this.getOperateAuth("addToWork") &&
            canCreateTask && (
              <Menu.Item
                onClick={this.props.taskOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoTask"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconrenwu" />
                  <span>{this.props.t("task")}</span>
                </div>
              </Menu.Item>
            )}

          {/* 日程 */}
          {((type === ChatMessageType.TEXT && !isMeetingCard) ||
            type === ChatMessageType.FILE ||
            type === ChatMessageType.IMAGE ||
            isCloudFileFunc(this.props.message)) &&
            crossAppSwitch("calendar") &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            !this.props.message?.quillImage?.length &&
            this.getOperateAuth("addToSchedule") &&
            checkScheduleVisible({ selectedSession }) && (
              <Menu.Item
                onClick={this.props.scheduleOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoSchedule"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconricheng" />
                  <span>{this.props.t("schedule")}</span>
                </div>
              </Menu.Item>
            )}

          {/* 催办 */}
          {trigger === "right-click" && type === ChatMessageType.TEXT &&
            !isMeetingCard &&
            !isOutApp &&
            checkRemindVisible({ selectedSession }) &&
            crossAppSwitch("supervise") &&
            !this.props.message?.quillImage?.length &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP && (
              <Menu.Item
                onClick={this.props.remindOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoUrgy"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconcuiban2" />
                  <span>{this.props.t("warn")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 消息组标记 */}
          {/* 0取消 1标记 tagCancel */}
          {selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
            type === ChatMessageType.TEXT &&
            message.mid !== 0 &&
            message.statusType !== MessageStatus.FAILED &&
            message.statusType !== MessageStatus.SENDING &&
            (message as any).nativeId !== "share_link" &&
            crossAppSwitch("message") &&
            allEmoji(message.content || "") &&
            !isOutApp &&
            !isMeetingInviteMsg(message.content || "") &&
            allEmoji(message.content || "") &&
            (isGroupOwner(groupRosterIdentity) || isGroupAdmin(groupRosterIdentity)) && (
              <Menu.Item onClick={this.props.handleMsgTag}>
                <div className="operate-menu-item">
                  <IconFont
                    className="icon"
                    type={`${message?.tag === 1 ? "iconic_app_unmark" : "iconic_app_mark"}`}
                  />
                  {message?.tag === 1 ? (
                    <span>{this.props.t("tagCancel")}</span>
                  ) : (
                    <span>{this.props.t("tag")}</span>
                  )}
                </div>
              </Menu.Item>
            )}
          {type === ChatMessageType.TEXT && assistantAI?.isAssistantAI === 1 && (
            <Menu.Item onClick={this.openAIAssistant}>
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconlianxiang1" />
                <span>AI联想</span>
              </div>
            </Menu.Item>
          )}
          {/** 快捷回复 */}
          {rightOpenReply &&
            canOpenReply &&
            selectedSession.sessionType === SessionType.GROUP &&
            type === ChatMessageType.TEXT && (
              <Menu.Item onClick={this.props.openQuickReply}>
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconapp_btn_reply" />
                  <span>{this.props.t("quick_reply")}</span>
                </div>
              </Menu.Item>
            )}
            {/* 删除 */}
          {this.showOperateFn("delEnabled") && (
            <Menu.Item
              onClick={this.props.deleteOperate}
              clstag="pageclick|keycount|Xtbg_Msg|InfoDelete"
            >
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconquanjushanchu" />
                <span>{this.props.t("delete")}</span>
              </div>
            </Menu.Item>
          )}
        </Menu>
      );
    }
    if (message.plusList) {
      return (
        <Menu selectedKeys={[""]}>
          {/* 复制 --hujun */}
          {(type === ChatMessageType.TEXT || type === ChatMessageType.IMAGE) && (
            <Menu.Item
              onClick={this.props.copyOperate}
              clstag="pageclick|keycount|Xtbg_Msg|InfoCopy"
            >
              <div className="operate-menu-item">
                <IconFont className="icon" type="iconapp_btn_copy" />
                <span>{this.props.t("copy")}</span>
              </div>
            </Menu.Item>
          )}
          {/* 撤回 */}
          {message.plusList &&
            type1 === MessageSendType.OWNER &&
            !more3 &&
            selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP && (
              <Menu.Item
                onClick={this.props.undoMsgOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoRevoke"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconapp_btn_undo" />
                  <span>{this.props.t("undo")}</span>
                </div>
              </Menu.Item>
            )}
          {/* 转发 */}
          {selectedSession.sessionType !== SessionType.MEETING_GROUP &&
            selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP && (
              <Menu.Item
                onClick={this.props.forwardOperate}
                clstag="pageclick|keycount|Xtbg_Msg|InfoShare"
              >
                <div className="operate-menu-item">
                  <IconFont className="icon" type="iconapp_btn_forwarding" />
                  <span>{this.props.t("forwarding")}</span>
                </div>
              </Menu.Item>
            )}
        </Menu>
      );
    }
  };

  handleReplyClick = () => {
    this.props.unLock();
    const { message, t, selectedSession } = this.props;
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const { appRuntimeEnv } = this.context;
      const { im } = appRuntimeEnv;
      if (this.props.updateSessionMessageMid) {
        const isExpired = checkFileIsExpired({
          // expiredAppKey: imAppKey,
          message: message as any,
          updateSessionMessageMid: this.props.updateSessionMessageMid,
          expiredTime: im.fileExpiredTime,
          type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
        });
        if (isExpired) return;
      }
    }
    let content = getReplyMessageDesc(message, selectedSession);
    ChatEvent.emitReply({
      replyUser: message.sender as Employee,
      replyText: content,
      replyMessage: message
    });
  };

  handleExpressionClick = () => {
    // 点击表情也可以关闭表情回复
    if (this.state.expressionVisible) {
      this.setState({ expressionVisible: false });
      return;
    }
    this.setState({ expressionVisible: true });
  };

  onDropdown = (e: any) => {
    const { message } = this.props;
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const { appRuntimeEnv } = this.context;
      const { im } = appRuntimeEnv;
      if (this.props.updateSessionMessageMid) {
        const isExpired = checkFileIsExpired({
          // expiredAppKey: imAppKey,
          message: message as any,
          updateSessionMessageMid: this.props.updateSessionMessageMid,
          expiredTime: im.fileExpiredTime,
          type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
        });
        if (isExpired) return;
      }
    }
    const box: any = document.getElementById("message-box-container-scroll");
    const cu = box.clientHeight;
    if (cu - (document.body.clientHeight - e.clientY) + 234 < 234) {
      this.setState({
        topStatus: true
      });
    } else {
      this.setState({
        topStatus: false
      });
    }
  };

  openAIAssistant = () => {
    const { authInfo } = this.context;
    const { assistantAI } = this.props;
    const { message } = this.props;
    if (message?.content) {
      FocusSDK.launchAssistantSession({
        teamId: authInfo.selectedTeamId,
        token: authInfo.accessToken,
        question: message.content,
        ...assistantAI
      });
    }
  };

  getRemindOperateNode = () => {
    const { t, selectedSession, message, currentEmployee } = this.props;
    const type = this.props.message.type;
    const isMeetingCard = (message as any).meetingCard && (message as any).meetingCard.meetingId;
    const isOutApp = selectedSession.isGroup
      ? isCrossPlatformGroupSession(selectedSession)
      : isOuterContacts(selectedSession, currentEmployee);
    const isMeetingGroup = selectedSession.sessionType === SessionType.MEETING_GROUP;
    const isText = type === ChatMessageType.TEXT;
    if (isText && !isMeetingCard &&
      !isOutApp &&
      checkRemindVisible({ selectedSession }) &&
      crossAppSwitch("supervise") &&
      !this.props.message?.quillImage?.length &&
      !isMeetingGroup) {
      return (
        <>
          <div className="operate-box-item" onClick={this.props.remindOperate}
            clstag="pageclick|keycount|Xtbg_Msg|InfoUrgy">
            <Tooltip overlayStyle={{fontSize: "12px"}} placement="top" title="催办">
              <IconFont className="icon" type="iconcuiban2" />
            </Tooltip>
          </div>
        <Divider style={{margin: "0px 1px", color: "#DBDBDC"}} type="vertical" />
        </>

      )
    }else{
      return null;
    }
  }

  canEmojiReply = () => {
    const { message, quickReplys = [] } = this.props;
    const isMeetingCard = (message as any).meetingCard && (message as any).meetingCard.meetingId;
    return !isQuillMsg(message?.quillJson) &&
      !isMeetingCard &&
      !isShortLinkMessage(message) &&
      !isQuickReplyCard(message) &&
      quickReplys.length;
  };



  render() {
    const { t, selectedSession, message, isRightClick } = this.props;
    const type = this.props.message.type;
     const canEmojiReply = this.canEmojiReply();
    return (
      <div
        className="operate-control-container"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {isRightClick && this.showOperateFn() && this.getDropdownMenu("right-click")}
        {(selectedSession?.isGroup === true || selectedSession?.isMeeting === true) &&
        message.plusList ? (
          <div className="operate-control-menu">{this.getDropdownMenu("right-click")}</div>
        ) : (
          !isRightClick &&
          message.type !== ChatMessageType.SOLITAIRE &&
          selectedSession.sessionType !== SessionType.MEETING_GROUP &&
          selectedSession.sessionType !== SessionType.LIVE_MEETING_GROUP &&
          selectedSession.sessionType !== SessionType.NOTICE &&
          this.showOperateFn() &&
          (
            <div
              className="operate-box"
              id="operate-box"
              onContextMenu={(e) => {
                e.stopPropagation();
                // e.preventDefault();
              }}
            >
              { canEmojiReply && type === ChatMessageType.TEXT && (
                <>
                <Dropdown
                  overlay={() => {
                    return this.getQuickReplysNode();
                  }}
                  // align={{ offset: [3, 0] }} // 微调位置
                  placement={this.state.topStatus === true ? "bottomRight" : "topRight"}
                  // onVisibleChange={this.onVisibleChange}
                  trigger={["hover"]}
                  getPopupContainer={() => document.getElementById("operate-box") as HTMLElement}
                >
                 <div className="operate-box-item" onClick={this.onDropdown}>
                   <Tooltip overlayStyle={{fontSize: "12px"}} placement="top" title="常用语">
                   <IconFont className="icon" type="icontiebiaoqing" />
                  </Tooltip>
              </div>
              </Dropdown>
              <Divider style={{margin: "0px 1px", color: "#DBDBDC"}} type="vertical" />
                </>
              )
              }
              {/* 引用 */}
              {this.showOperateFn("replyEnabled") && !isOrgChatSession(selectedSession) && (
                <>
                <div
                  className="operate-box-item"
                  onClick={() => this.handleReplyClick()}
                  clstag="pageclick|keycount|Xtbg_Msg|FrequencyQuote"
                >
                  <Tooltip overlayStyle={{fontSize: "12px"}} placement="top" title={t('quote')}>

                  <IconFont className="icon" type="iconhuifu1" />

                  </Tooltip>
                </div>
                <Divider style={{margin: "0px 1px", color: "#DBDBDC"}} type="vertical" />
                </>
              )}


              {/* 转发 */}
              {!checkIsSummaryCard(message) &&
                !checkisLiveCard(message) &&
                !isOrgNoticeMultiMessage(message) &&
                this.showOperateFn("forwardEnabled") && (
                  <>

                  <div
                    className="operate-box-item"
                    onClick={() => this.props.forwardOperate()}
                    clstag="pageclick|keycount|Xtbg_Msg|FrequencyShare"
                  >
                    <Tooltip overlayStyle={{fontSize: "12px"}} placement="top" title={t('forwarding')}>
                    <IconFont className="icon" type="iconzhuanfa" />
                    </Tooltip>
                  </div>
                   <Divider style={{margin: "0px 1px", color: "#DBDBDC"}} type="vertical" />
                   </>
                )}

                {/* 催办 */}
                {this.getRemindOperateNode()}
              <div className="operate-box-item" onClick={this.onDropdown}>
                <Dropdown
                  overlay={() => {
                    return <div>{this.getDropdownMenu("more-operation")}</div>;
                  }}
                  placement={this.state.topStatus === true ? "bottomRight" : "topRight"}
                  align={{ offset: [-24, this.state.topStatus ? -50 : 50] }} // 微调位置
                  onVisibleChange={this.onVisibleChange}
                  trigger={["click"]}
                  getPopupContainer={() => document.getElementById("operate-box") as HTMLElement}
                >
                  <Tooltip overlayStyle={{fontSize: "12px"}} placement="top" title={t('more_operate')}>
                  <IconFont className="icon" type="icongengduo1" />
                  </Tooltip>
                </Dropdown>
              </div>
            </div>
          )
        )}
      </div>
    );
  }
}

export default withTranslation("chat")(MessageOperate);
